// extracted by mini-css-extract-plugin
module.exports = {"container":"projects_container__3gthd","project":"projects_project__2Zu03","box":"projects_box__DqiNJ","head":"projects_head__FP8WZ"};